import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/pastelTheme.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import AppNavbar from './components/Navbar';

// Route Protection
import { PrivateRoute, AdminRoute, PublicRoute } from './utils/PrivateRoute';

// Public Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';

// Developer Pages
import DeveloperDashboard from './pages/developer/Dashboard';
import SubmitReport from './pages/developer/SubmitReport';
import ViewReports from './pages/developer/ViewReports';
import ReportDetail from './pages/developer/ReportDetail';
import EditReport from './pages/developer/EditReport';

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminViewReports from './pages/admin/ViewReports';
import AdminReportDetail from './pages/admin/ReportDetail';
import ManageProjects from './pages/admin/ManageProjects';
import ProjectHours from './pages/admin/ProjectHours';
import UsersManagement from './pages/admin/UsersManagement';
import ProjectSummary from './pages/admin/ProjectSummary';

// Task Management Pages
import TasksPage from './pages/tasks/TasksPage';
import TaskDetailPage from './pages/tasks/TaskDetailPage';
import NewTaskPage from './pages/tasks/NewTaskPage';
import EditTaskPage from './pages/tasks/EditTaskPage';
import ProjectTasksPage from './pages/tasks/ProjectTasksPage';



function App() {
  return (
    <Router>
      <AuthProvider>
        <AppNavbar />
        <Container className="py-4" style={{ marginTop: '75px' }}>
          <Routes>
            {/* Public Routes */}
            <Route element={<PublicRoute />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
            </Route>
            {/* Developer Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<DeveloperDashboard />} />
              <Route path="/reports/new" element={<SubmitReport />} />
              <Route path="/reports/edit/:id" element={<EditReport />} />
              <Route path="/reports/:id" element={<ReportDetail />} />
              <Route path="/reports" element={<ViewReports />} />
            </Route>

            {/* Admin Routes */}
            <Route element={<AdminRoute />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/reports" element={<AdminViewReports />} />
              <Route path="/admin/reports/:id" element={<AdminReportDetail />} />
              <Route path="/admin/register" element={<Register />} />
              <Route path="/admin/projects" element={<ManageProjects />} />
              <Route path="/admin/projects/:projectId/summary" element={<ProjectSummary />} />
              <Route path="/admin/project-hours" element={<ProjectHours />} />
              <Route path="/admin/users" element={<UsersManagement />} />
            </Route>

            {/* Task Management Routes - Accessible to both admin and users */}
            <Route element={<PrivateRoute />}>
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/tasks/new" element={<NewTaskPage />} />
              <Route path="/tasks/project/:projectId" element={<ProjectTasksPage />} />
              <Route path="/tasks/:id" element={<TaskDetailPage />} />
              <Route path="/tasks/edit/:id" element={<EditTaskPage />} />
            </Route>

            {/* Fallback Route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Container>
      </AuthProvider>
    </Router>
  );
}

export default App;
